// assets/infinite-slide.js
window.InfiniteSlide = (() => {
  const inited = new WeakSet();

  function setupOne(slide) {
    if (inited.has(slide)) return;
    inited.add(slide);

    // Leave the content static (no clones, no motion) for anyone who has
    // asked the OS for reduced motion — this loop otherwise runs forever.
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const direction = slide.dataset.style || "left"; // left/right/up/down
    const cloneCount = parseInt(slide.dataset.clone, 10) || 1;
    const speed = parseFloat(slide.dataset.speed) || 50; // px/s
    const pauseOnHover = slide.dataset.pauseonhover !== "false";
    const isVertical = direction === "up" || direction === "down";
    const isReverse = direction === "right" || direction === "down";

    // wrapper
    let wrapper = slide.parentElement;
    if (!wrapper || !wrapper.classList.contains("infiniteslide_wrap")) {
      wrapper = document.createElement("div");
      wrapper.className = "infiniteslide_wrap";
      wrapper.style.overflow = "hidden";
      slide.parentNode.insertBefore(wrapper, slide);
      wrapper.appendChild(slide);
    }

    // styles
    slide.style.display = "flex";
    slide.style.flexWrap = "nowrap";
    slide.style.alignItems = "center";
    slide.style.willChange = "transform";
    slide.style.flexDirection = isVertical ? "column" : "row";

    Array.from(slide.children).forEach(child => {
      child.style.flex = "none";
    });

    // clone
    if (!slide.querySelector(".infiniteslide_clone")) {
      const children = Array.from(slide.children);
      for (let i = 0; i < cloneCount; i++) {
        children.forEach(child => {
          const clone = child.cloneNode(true);
          clone.classList.add("infiniteslide_clone");
          clone.setAttribute("aria-hidden", "true");
          clone.style.flex = "none";
          slide.appendChild(clone);
        });
      }
    }

    let isPaused = false;

    if (pauseOnHover) {
      wrapper.addEventListener("mouseenter", () => { isPaused = true; }, { passive: true });
      wrapper.addEventListener("mouseleave", () => { isPaused = false; }, { passive: true });
    }

    const state = { raf: null, stopped: false };
    slide.__infiniteState = state;

    let lastTime = null;
    let translate = 0;
    let initializedOffset = false;

    function getTotalSize() {
      const total = isVertical
        ? slide.scrollHeight / (cloneCount + 1)
        : slide.scrollWidth / (cloneCount + 1);

      return total || 0;
    }

    function render() {
      if (isVertical) {
        slide.style.transform = `translateY(${translate}px)`;
      } else {
        slide.style.transform = `translateX(${translate}px)`;
      }
    }

    function animate(now) {
      if (state.stopped) return;

      const totalSize = getTotalSize();
      if (!totalSize) {
        state.raf = requestAnimationFrame(animate);
        return;
      }

      // right/down phải bắt đầu từ -totalSize để không bị hở 1 bên
      if (!initializedOffset) {
        translate = isReverse ? -totalSize : 0;
        render();
        initializedOffset = true;
      }

      if (!lastTime) lastTime = now;
      const dt = (now - lastTime) / 1000;
      lastTime = now;

      if (!isPaused) {
        if (direction === "left" || direction === "up") {
          translate -= speed * dt;

          if (-translate >= totalSize) {
            translate = 0;
          }
        } else {
          translate += speed * dt;

          if (translate >= 0) {
            translate = -totalSize;
          }
        }

        render();
      }

      state.raf = requestAnimationFrame(animate);
    }

    state.raf = requestAnimationFrame(animate);
  }

  function mountAll(root = document) {
    root.querySelectorAll(".infiniteSlide").forEach(setupOne);
  }

  function destroy(slide) {
    const state = slide && slide.__infiniteState;
    if (state) {
      state.stopped = true;
      if (state.raf) cancelAnimationFrame(state.raf);
    }
  }

  return { mountAll, destroy };
})();

document.addEventListener("DOMContentLoaded", () => {
  window.InfiniteSlide.mountAll(document);

  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        window.InfiniteSlide.mountAll(document);
        break;
      }
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
});